import CareplanPage from "./Order/CareplanPage";
import ErrorPage from "./Shared/ErrorPage/ErrorPage";
import SentryErrorPage from "./Shared/ErrorPage/SentryErrorPage";
import CommandCenter from "./CommandCenter/CommandCenter";
import DosimetristPlanningAutomation from "./OrderTracker/DosimetristPlanningAutomation";
import Metrics from "./Metrics/Metrics";
import DeploymentDashboardPage from "./DeploymentDashboard/DeploymentDashboardPage";

export {
  CareplanPage,
  ErrorPage,
  SentryErrorPage,
  CommandCenter,
  DosimetristPlanningAutomation,
  Metrics,
  DeploymentDashboardPage,
};

// Patching out some console warnings that are currently unavoidable so they don't clutter up the console for devs
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (
    args[0].includes(
      "A textarea element was provided to Autocomplete where input was expected.",
    )
  ) {
    return;
  }
  originalConsoleWarn(...args);
};
